<template>
    <div class="w-full">
        <div class="flex flex-col items-center justify-between gap-4 md:items-start">
            <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-2">
                    <p class="text-xs font-bold text-gray-500 sm:text-sm" v-html="productForm().extraDetailsInfo.description" />
                    <Allergies v-if="productForm().extraDetailsInfo.allergies" :id="`${props.id}modal`" :allergies="productForm().extraDetailsInfo.allergies" />
                </div>
            </div>
            <ModalProductImage :image="productForm().extraDetailsInfo.image" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import Allergies from '~/components/Allergies.vue'
    import ModalProductImage from '~/components/Modal/ModalProduct/ModalProductImage.vue'
    import { productForm } from '~/store/productForm'
    const props = defineProps<ProductOrderBuddy>()
</script>
